import { ApiClient } from "./ApiClient";
import { RealmLower } from "../constants";
import { WorkflowExecution, RedriveResponse, ServiceResult } from "./index";
import { toErrorMessage } from "../utils/ErrorMessage";

export class WorkflowService {
  private api: ApiClient;

  constructor(api: ApiClient = ApiClient.getInstance()) {
    this.api = api;
  }

  async getWorkflows(realm: RealmLower, customerId: string): Promise<ServiceResult<WorkflowExecution[]>> {
    try {
      const base = this.api.getBaseUrl("workflow-statuses", realm);
      const region = this.api.getRegionCode(realm);
      const data = await this.api.get<WorkflowExecution[]>(`${base}/workflow-statuses?customerId=${customerId}&region=${region}`);
      return { status: "ok", data };
    } catch (err) {
      return { status: "error", message: toErrorMessage(err) };
    }
  }

  async redrive(realm: RealmLower, executionArn: string): Promise<RedriveResponse> {
    const region = this.api.getRegionCode(realm);
    return this.api.post(`${this.api.getBaseUrl("redrive", realm)}/redrive?region=${region}`, { executionArn });
  }
}
